module.exports = __webpack_public_path__ + "img/multicare_product.9cb0aa54.webp";